import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Container, SectionLabel } from "../components/ui-kit";
import PageHero from "../components/PageHero";
import { HandHeart, Globe2, Users, FileText } from "lucide-react";
import AnimatedCounter from "../components/AnimatedCounter";

export default function Impact() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  const enabled = settings?.impact_dashboard_enabled;
  const metrics = settings?.impact_metrics || [];

  return (
    <div>
      <PageHero
        label="Impact"
        title="Our Impact Dashboard"
        subtitle="A transparent view of our reach and outcomes. All metrics are published only after internal verification."
        crumbs={[{ label: "Impact" }]}
      />

      <section id="reach" className="scroll-mt-28 bg-white" data-testid="impact-dashboard">
        <Container className="py-16">
          {enabled && metrics.length > 0 ? (
            <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
              {metrics.map((m) => (
                <div key={m.label} className="rounded-2xl border border-emerald-900/10 bg-sand p-7 text-center">
                  <div className="font-display text-4xl font-bold text-emerald-900"><AnimatedCounter value={m.value} suffix={m.suffix || ""} /></div>
                  <div className="mt-1 text-xs font-medium uppercase tracking-wider text-slate-500">{m.label}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="rounded-3xl border border-dashed border-emerald-900/20 bg-sand p-16 text-center">
              <HandHeart className="mx-auto h-10 w-10 text-gold" />
              <p className="mt-4 font-display text-3xl font-bold text-emerald-900">Building Impact Together</p>
              <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-slate-500">We publish verified impact metrics as our initiatives progress with trusted partners. We do not display unverified or fabricated statistics.</p>
            </div>
          )}
        </Container>
      </section>

      <section id="stories" className="scroll-mt-28 bg-sand">
        <Container className="py-16">
          <div className="grid gap-8 md:grid-cols-3">
            {[[Globe2, "Our Reach", "Programs coordinated across UAE, South Asia, the Middle East and beyond."], [Users, "Stories of Change", "Human stories will be shared here, told with dignity and consent."], [FileText, "Impact Reports", "Completed initiatives include downloadable impact reports where available."]].map(([Icon, title, text]) => (
              <div key={title} id={title === "Impact Reports" ? "reports" : undefined} className="scroll-mt-28 rounded-2xl border border-emerald-900/10 bg-white p-7">
                <Icon className="h-7 w-7 text-emerald-800" />
                <h3 className="mt-4 font-display text-xl font-bold text-emerald-900">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{text}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
